
















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { CAMERA } from "@/resources/constants/camera";
import { RED } from "@/resources/constants/busyReasons";
@Component({
  name: "camera-options-component",
})
export default class CameraOptionsComponent extends Vue {
  moveCameraActive: any;
  rotationCameraActive: any;
  CAMERA = CAMERA;
  collapse = false;
  city = false;
  created(): void {
    this.moveCameraActive = false;
    this.rotationCameraActive = false;
    this.city = localStorage.getItem("city") == "ON" ? false : true;
  }

  get openChat(): boolean {
    const openChat = this.$store.getters["SidebarStore/getOpenChat"];
    return openChat;
  }
  get openCall(): boolean {
    const openCall = this.$store.getters["SidebarStore/getOpenCall"];
    return openCall;
  }

  @Watch("openChat")
  @Watch("openCall")
  changeCollapse(val, oldVal) {
    const changeStatus = this.openCall ? this.openCall : this.openChat;
    this.collapse = changeStatus;
  }

  get active(): boolean {
    return this.$store.getters["SystemStore/getShowCameraOptions"];
  }
  get maxZoom(): number {
    return this.$store.getters["SystemStore/getMaxZoom"];
  }
  get minZoom(): number {
    return this.$store.getters["SystemStore/getMinZoom"];
  }
  get zoom(): number {
    return this.$store.getters["SystemStore/getZoom"];
  }
  set zoom(value: number) {
    this.$store.dispatch("SystemStore/setZoomAction", value);
    this.$store.dispatch("GraphicClientStore/setZoom", value);
  }
  moveCamera(direction: string): void {
    const data = {
      value: CAMERA.SPEED_MOVE,
      direction: direction,
    };
    if (!this.moveCameraActive) {
      this.moveCameraActive = setInterval(() => {
        this.$store.dispatch("GraphicClientStore/moveCamera", data);
      });
    }
  }
  moveCameraStop(): void {
    clearInterval(this.moveCameraActive);
    this.moveCameraActive = false;
  }
  rotationCamera(value: number, direction: string): void {
    const data = {
      value: value,
      direction: direction,
    };
    if (!this.rotationCameraActive) {
      this.rotationCameraActive = setInterval(() => {
        this.$store.dispatch("GraphicClientStore/rotationCamera", data);
      });
    }
  }
  rotationCameraStop(): void {
    clearInterval(this.rotationCameraActive);
    this.rotationCameraActive = false;
  }
  focus() {
    const user = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch(
      "GraphicClientStore/focusUserAction",
      user.superSpaceUser.user.id
    );
  }
}
